import React from 'react';
import { Facebook } from 'lucide-react';
import { Link } from 'react-router-dom';
import { BrandLogo } from './BrandLogo';
export const Footer: React.FC = () => {
  return <footer className="bg-brand-emerald text-white py-16" data-id="element-46">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-47">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 items-center mb-12" data-id="element-48">
          {/* Left: Logo & Tagline */}
          <div className="flex flex-col items-center md:items-start text-center md:text-left" data-id="element-49">
            <BrandLogo widthPx={300} variant="white" className="mb-5" data-id="element-50" />
            <p className="text-sm italic text-brand-mint max-w-xs leading-relaxed" data-id="element-51">
              Tu cuerpo tiene un código. Aquí te ayudamos a descifrarlo.
            </p>
          </div>

          {/* Center: Links */}
          <div className="flex flex-col sm:flex-row justify-center items-center gap-4 sm:gap-8 text-sm font-medium text-white" data-id="element-52">
            <Link to="/privacidad" className="hover:underline underline-offset-4 transition-all" data-id="element-53">
              Política de Privacidad
            </Link>
            <span className="hidden sm:block text-white/30" data-id="element-54">|</span>
            <Link to="/terminos" className="hover:underline underline-offset-4 transition-all" data-id="element-55">
              Términos
            </Link>
          </div>

          {/* Right: Social */}
          <div className="flex justify-center md:justify-end items-center" data-id="element-56">
            <a href="#" className="flex items-center gap-2 text-white hover:opacity-80 transition-opacity" data-id="element-57">
              <Facebook className="w-5 h-5 text-white" data-id="element-58" />
              <span className="text-sm font-medium" data-id="element-59">@ElCódigoDelBienestar</span>
            </a>
          </div>
        </div>

        <div className="pt-8 border-t border-white/15 text-center text-sm text-brand-mint" data-id="element-60">
          <p data-id="element-61">© 2026 El Código del Bienestar. Todos los derechos reservados.</p>
        </div>
      </div>
    </footer>;
};